"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CITIZEN_STATUS_FIELDS = void 0;
var entities_1 = require("@common/entities");
var constants_1 = require("../../constants");
exports.CITIZEN_STATUS_FIELDS = [
    __assign(__assign({}, entities_1.CitizenStatusFields.citizenshipTypeId), { type: entities_1.FieldType.Dropdown, enabled: true, required: true, isConfigurable: false, sequence: 1, customType: entities_1.FieldType.Dropdown }),
    __assign(__assign({}, entities_1.CitizenStatusFields.hasSsn), { type: entities_1.FieldType.YesNo, customType: entities_1.FieldType.YesNo, options: constants_1.YES_NO_OPTIONS, enabled: true, isConfigurable: false, sequence: 2, required: true }),
    __assign(__assign({}, entities_1.CitizenStatusFields.ssnNumber), { type: entities_1.FieldType.SSN, customType: entities_1.FieldType.SSN, enabled: true, required: true, isConfigurable: false, sequence: 3 }),
    __assign(__assign({}, entities_1.CitizenStatusFields.ssnException), { type: entities_1.FieldType.Radio, customType: entities_1.FieldType.Radio, options: constants_1.SSN_EXCEPTION_OPTIONS, enabled: true, required: true, sequence: 4 }),
    __assign(__assign({}, entities_1.CitizenStatusFields.tracsId), { type: entities_1.FieldType.Text, customType: entities_1.FieldType.Text, enabled: true, required: true, sequence: 5 }),
];
